import type { ExtractPropTypes, PropType } from 'vue'

export type TooltipPlacement =
  | 'top'
  | 'top-start'
  | 'top-end'
  | 'bottom'
  | 'bottom-start'
  | 'bottom-end'
  | 'left'
  | 'left-start'
  | 'left-end'
  | 'right'
  | 'right-start'
  | 'right-end'

export const tooltipProps = {
  /**
   * 文字提示内容
   */
  content: {
    type: String,
    default: ''
  },
  /**
   * 提示框出现的位置
   */
  placement: {
    type: String as PropType<TooltipPlacement>,
    default: 'top'
  },
  /**
   * 触发方式
   */
  trigger: {
    type: String as PropType<'hover' | 'click' | 'focus'>,
    default: 'hover'
  },
  /**
   * 是否禁用提示框
   */
  disabled: {
    type: Boolean,
    default: false
  },
  /**
   * 出现延迟，单位毫秒
   */
  showDelay: {
    type: Number,
    default: 0
  },
  /**
   * 隐藏延迟，单位毫秒
   */
  hideDelay: {
    type: Number,
    default: 200
  },
  /**
   * 是否显示箭头
   */
  showArrow: {
    type: Boolean,
    default: true
  },
  /**
   * 自定义类名
   */
  tooltipClass: {
    type: String,
    default: ''
  },
  /**
   * 是否启用动画效果
   */
  transition: {
    type: String,
    default: 'cms-tooltip-fade'
  },
  /**
   * 是否手动控制显示状态
   */
  manual: {
    type: Boolean,
    default: false
  },
  /**
   * 是否显示（受控模式）
   */
  modelValue: {
    type: Boolean,
    default: undefined
  },
  /**
   * 主题
   */
  effect: {
    type: String as PropType<'dark' | 'light'>,
    default: 'dark'
  }
} as const

export type TooltipProps = Partial<ExtractPropTypes<typeof tooltipProps>>

export const tooltipEmits = {
  'update:modelValue': (value: boolean) => typeof value === 'boolean',
  'before-show': () => true,
  'before-hide': () => true,
  'show': () => true,
  'hide': () => true
}

export type TooltipEmits = typeof tooltipEmits